module.exports = __webpack_public_path__ + "assets/676874b2a143e67bb56058e82b181722.png";